export const moduloUm = [
    {
        "id": "1",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte I_v2.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Parte I_v2.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte II_1.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Parte II_1.pdf",
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Treinamento.pdf",
        "path": "./treinamento/Treinamento.pdf",
        "type": "pdf"
    },
]